import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTopButton from '@/components/base/ScrollToTopButton';
import SEO from '@/components/feature/SEO';
import HeroSection from './components/HeroSection';
import CategoryNav from './components/CategoryNav';
import MovieGrid from './components/MovieGrid';
import HotMovies from './components/HotMovies';
import FAQSection from './components/FAQSection';
import { getNewMovies, getHotMovies, getFeaturedMovies, siteInfo } from '@/mocks/movies';

export default function Home() {
  const newMovies = getNewMovies().slice(0, 12);
  const hotMovies = getHotMovies().slice(0, 6);
  const featuredMovies = getFeaturedMovies().slice(0, 12);

  const jsonLd = {
    '@context': 'https://schema.org',
    '@graph': [
      {
        '@type': 'Organization',
        name: siteInfo.name,
        url: siteInfo.url,
        description: siteInfo.description,
        email: siteInfo.email,
        telephone: siteInfo.phone,
        address: {
          '@type': 'PostalAddress',
          addressLocality: '北京',
          addressCountry: 'CN',
          streetAddress: siteInfo.address,
        },
      },
      {
        '@type': 'WebSite',
        name: siteInfo.name,
        url: siteInfo.url,
        description: siteInfo.description,
        potentialAction: {
          '@type': 'SearchAction',
          target: `${siteInfo.url}/search?q={search_term_string}`,
          'query-input': 'required name=search_term_string',
        },
      },
      {
        '@type': 'WebPage',
        name: `${siteInfo.name} - ${siteInfo.tagline}`,
        url: siteInfo.url,
        description: siteInfo.description,
        isPartOf: { '@type': 'WebSite', '@id': `${siteInfo.url}/#website` },
        about: { '@type': 'Organization', '@id': `${siteInfo.url}/#organization` },
      },
    ],
  };

  return (
    <>
      <SEO
        title="97影院 - 电影大全免费在线观看 | 最新热播电影经典电影，高清蓝光不卡顿"
        description="97影院电影大全，提供最新电影、热播电影、经典电影免费在线观看。动作片、喜剧片、科幻片等高清蓝光画质，不卡顿流畅播放。电影大全，最新电影，经典电影尽在97影院。"
        keywords="电影大全,最新电影,经典电影,免费在线观看,动作片,喜剧片,科幻片,高清电影,蓝光,97影院,不卡顿"
        canonical="https://www.97cinema.com/"
        ogTitle="97影院 - 电影大全免费在线观看"
        ogDescription="最新电影、热播电影、经典电影免费在线观看，高清蓝光画质不卡顿流畅播放"
      />

      <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>

      <div className="min-h-screen bg-background-50">
        <Navbar />
        <main>
          <HeroSection />
          <CategoryNav />
          {featuredMovies.length > 0 && (
            <MovieGrid
              title="精选"
              accentText="推荐"
              subtitle="精心挑选的优质电影，每一部都值得一看"
              movies={featuredMovies}
            />
          )}
          {newMovies.length > 0 && (
            <MovieGrid
              title="最新"
              accentText="上线"
              subtitle="刚刚上线的最新电影，抢先观看"
              movies={newMovies}
            />
          )}
          {hotMovies.length > 0 && <HotMovies movies={hotMovies} />}
          <FAQSection />
        </main>
        <Footer />
        <ScrollToTopButton />
      </div>
    </>
  );
}